'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@module/mdrt-org/shared/components/chip/chip';
import { SEARCH_CONTENT_TYPE_PARAM_KEY } from '@module/mdrt-org/shared/utils/constants/learn-search-constants';
import { ContentType } from '@module/mdrt-org/shared/utils/data/constants/content-type';
import { ChipTheme } from '@shared/ui-components/chip/chipTheme';
import { type SearchCmsContent } from '../../graphql/get-search-cms-content';
import { type SearchPageSearchParameters } from '../../types';
import styles from './search-type-filter.module.scss';
export type SearchTypeFilterProps = {
  contentType: null | number;
  onContentTypeChange: (searchParameters: SearchPageSearchParameters) => void;
  searchPageCmsContent: SearchCmsContent['searchPage'];
};
export const SearchTypeFilter = t0 => {
  const $ = _c(25);
  const {
    contentType,
    onContentTypeChange,
    searchPageCmsContent
  } = t0;
  const t1 = searchPageCmsContent?.AllResourcesLabel || "All resources";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      label: t1,
      value: null
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = searchPageCmsContent?.ArticlesLabel || "Articles";
  let t4;
  if ($[2] !== t3) {
    t4 = {
      label: t3,
      value: ContentType.Article
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = searchPageCmsContent?.VideosLabel || "Videos";
  let t6;
  if ($[4] !== t5) {
    t6 = {
      label: t5,
      value: ContentType.Video
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = searchPageCmsContent?.AudioLabel || "Audio";
  let t8;
  if ($[6] !== t7) {
    t8 = {
      label: t7,
      value: ContentType.Audio
    };
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = searchPageCmsContent?.GuidesLabel || "Guides";
  let t10;
  if ($[8] !== t9) {
    t10 = {
      label: t9,
      value: ContentType.Guide
    };
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = searchPageCmsContent?.CoursesLabel || "Courses";
  let t12;
  if ($[10] !== t11) {
    t12 = {
      label: t11,
      value: ContentType.Course
    };
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== t10 || $[13] !== t12 || $[14] !== t2 || $[15] !== t4 || $[16] !== t6 || $[17] !== t8) {
    t13 = [t2, t4, t6, t8, t10, t12];
    $[12] = t10;
    $[13] = t12;
    $[14] = t2;
    $[15] = t4;
    $[16] = t6;
    $[17] = t8;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const contentTypeEntries = t13;
  let t14;
  if ($[19] !== onContentTypeChange) {
    t14 = nextContentType => {
      onContentTypeChange({
        [SEARCH_CONTENT_TYPE_PARAM_KEY]: nextContentType?.toString() ?? ""
      });
    };
    $[19] = onContentTypeChange;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const handleContentTypeChange = t14;
  let t15;
  if ($[21] !== contentType || $[22] !== contentTypeEntries || $[23] !== handleContentTypeChange) {
    const filterItems = contentTypeEntries.map(contentTypeEntry => {
      const isActiveFilter = contentType === contentTypeEntry.value;
      return <li key={contentTypeEntry.value}><Chip aria-current={isActiveFilter} aria-label={contentTypeEntry.label} label={contentTypeEntry.label} onClick={contentType === contentTypeEntry.value ? undefined : () => handleContentTypeChange(contentTypeEntry.value)} theme={isActiveFilter ? ChipTheme.Active : ChipTheme.Light} /></li>;
    });
    t15 = <ul className={styles["search-type-filter"]}>{filterItems}</ul>;
    $[21] = contentType;
    $[22] = contentTypeEntries;
    $[23] = handleContentTypeChange;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
};